export default class VoucherValidator {
  constructor(urlParams) {
    this.voucher = urlParams.get('voucher')
    this.checksum = urlParams.get('checksum')
  }

  isPresent() {
    return this.voucher && this.checksum
  }

  async isValid() {
    const encodedVoucher = new TextEncoder().encode(this.voucher)
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', encodedVoucher)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
    return hashHex === this.checksum
  }
}